import { Menu, MenuEntry, Typo3State, VehicleCenter } from './types';
import { T3Labels } from './types/states';

export const selectMenu = (
  { pathContent }: Typo3State,
  key: keyof Menu
): MenuEntry[] => {
  if (pathContent) {
    const { menu } = pathContent;
    return menu[key] || [];
  }
  return [];
};

export const selectVehicleCenters = ({
  staticContent
}: Typo3State): VehicleCenter[] => {
  if (staticContent) {
    return staticContent.vehicleCenters;
  }
  return [];
};

export const selectVehicleCentersMap = ({
  staticContent
}: Typo3State): Map<string, VehicleCenter> => {
  if (staticContent) {
    return staticContent.vehicleCentersMap;
  }
  return new Map();
};

export const selectLabels = ({ staticContent }: Typo3State): T3Labels => {
  return (staticContent && staticContent.labels) || {typo3: {}, usedVehicles: {}};
};

export const selectContent = ({ pathContent }: Typo3State) => {
  return (pathContent && pathContent.content) || [];
};

export const selectStage = ({ pathContent }: Typo3State) => {
  return (pathContent && pathContent.stage) || [];
};

export const selectCookie = ({ pathContent }: Typo3State) => {
  return (pathContent && pathContent.cookie) || null;
};

export const selectMeta = ({ pathContent }: Typo3State) => {
  return (pathContent && pathContent.meta) || null;
};

export const selectDoktype = (typo3: Typo3State) => {
  const meta = selectMeta(typo3);
  return meta ? meta.doktype : '';
};

export const selectSysLanguageIsocode = (typo3: Typo3State) => {
  const meta = selectMeta(typo3);
  return meta ? meta.sys_language_isocode : 'de';
};

export const selectFaqs = (typo3: Typo3State) => {
  const meta = selectMeta(typo3);
  return (meta && meta.faqs) || [];
};

export const selectIsPathContentLoaded = ({ pathContent }: Typo3State) => {
  return !!pathContent;
};

export const selectIsStaticContentLoaded = ({ staticContent }: Typo3State) => {
  return !!staticContent;
};

export const selectLayer = ({ staticContent }: Typo3State) => {
  return staticContent ? staticContent.layer : null;
};

export const selectSearchMenuEntry = (typo3: Typo3State): MenuEntry | undefined => {
  return selectMenu(typo3, 'search')[0];
}

/**
 * Look for search detail content and configured vehicleId.
 */
export const selectSearchDetailVehicleId = (typo3: Typo3State): string | undefined => {
  const content = selectContent(typo3);
  const {vehicleId} = content.find((piece) => piece.CType === 'searchdetail') || {};

  return vehicleId;
};
